<template lang="pug">
.box
    .box-header.header.b-b
        h3 Details

    .box-body
        label Outlet
        p {{ orderLayout.outlet.name }}
        
        label Assigned centrals

        .central-selector(v-if="canManageOrderLayout")

            p(v-if="centralOptions.length === 0") No centrals available.

            p(v-if="centralOptions.length <= 5" v-for="c in centralOptions")
                label.md-check
                    input(
                        type="checkbox"
                        v-model="assignedCentralsCheckbox"
                        :value="c.id"
                    )
                    i.indigo
                    | {{ c.name }}

            multiselect(
                deselect-label=""
                :options="centralOptions",
                label="name",
                track-by="id",
                placeholder="Select central devices",
                tag-placeholder="Create",
                select-label="",
                :multiple="true",
                v-model="assignedCentrals",
                v-if="centralOptions.length > 5"
                :close-on-select="false"
            )
        
        div(v-if="!canManageOrderLayout")
            div(v-if="assignedCentrals.length === 0") No central assigned
            div(v-else) {{ assignedCentrals.map(o => o.name).join(', ') }}
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import PermissionMixin from '../order-layout-permission';

export default {
    mixins: [PermissionMixin],

    computed: {
        ...mapGetters('central', ['centralList']),

        ...mapGetters('orderLayout', [
            'centrals',
            'excludeCentrals',
            'orderLayout',
        ]),

        assignedCentrals: {
            get() {
                return this.centrals;
            },

            set(centrals) {
                this.setCentrals(centrals);
            },
        },

        assignedCentralsCheckbox: {
            get() {
                return this.centrals.map(c => c.id);
            },

            set(newval) {
                let centralObjs = newval.map(id =>
                    this.centralOptions.find(c => c.id === id),
                );

                this.setCentrals(centralObjs);
            },
        },

        centralOptions() {
            return this.centralList
                .filter(c => !this.excludeCentrals.find(id => id == c.id))
                .filter(c => c.outlet_id == this.orderLayout.outlet_id);
        },
    },

    methods: {
        ...mapMutations('orderLayout', ['setCentrals']),
    },
};
</script>

<style lang="scss" scoped>
.central-selector {
    p:last-child {
        margin-bottom: 0;
    }
}

.box-body {
    & > label {
        font-weight: 500;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/order-layout/action/action-details.vue